import Cta from "@components/Cta/Cta";
import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";
import { TinyMceRichText } from "@customTypes/TinyMceRichText";
import clsx from "clsx";
import { ReactNode, useEffect, useState } from "react";
import { ItemState } from "./Accordion";
import styles from "./C11_VerticalAccordion.module.scss";

export interface AccordionItemProps {
  content: any;
  contentTinyMce: TinyMceRichText;
  childContent?: ReactNode;
  title: ReactNode;
  accordionState: ItemState;
  item: number;
  contextLabelId?: string;
  toggleAccordion: (event, item) => void;
}

export const AccordionItem = (props: AccordionItemProps) => {
  const {
    content,
    childContent,
    title,
    contentTinyMce,
    accordionState,
    item,
    contextLabelId,
    toggleAccordion,
  } = props;
  const [isVisible, setVisibility] = useState(false);
  const [contentHeight, setContentHeight] = useState(
    accordionState.contentHeight
  );
  const isRichText =
    content?.nodeType === "document" || contentTinyMce?.nodeType === "document";
  const isArray = Array.isArray(content) && content?.length > 0;
  let isLinkList = false;

  if (isArray)
    isLinkList = content.some(
      (link) => (!!link?.url || !!link?.contentReference) && link?.linkText
    );

  useEffect(() => {
    // Set height for animation
    setContentHeight(accordionState.contentHeight);

    // If it's open, set visibility and set content to auto so it can be responsive on resize
    if (accordionState.isOpen) {
      setVisibility(true);

      setTimeout(() => {
        setContentHeight("auto");
      }, 300);
    } else {
      setTimeout(() => {
        setContentHeight("0");
      }, 10);

      setTimeout(() => {
        setVisibility(false);
      }, 300);
    }
  }, [accordionState.isOpen]);

  return (
    <li>
      <button
        id={`${contextLabelId ?? "acc"}-toggle-${item}`}
        className={clsx(styles["toggle-link"], "font-bold flex items-center")}
        aria-expanded={isVisible}
        onClick={(e) => {
          toggleAccordion(e, item);
        }}
        aria-controls={`panel-id-${item}`}
        aria-labelledby={
          contextLabelId
            ? `${contextLabelId ?? "acc"}-toggle-${item} ${contextLabelId}`
            : `${contextLabelId ?? "acc"}-toggle-${item}`
        }
      >
        {title}
      </button>
      <div
        className={styles["accordion-drop"]}
        aria-hidden={!isVisible}
        style={{
          visibility: isVisible ? "visible" : "hidden",
          height: contentHeight,
        }}
        id={`panel-id-${item}`}
      >
        <div className={styles["content"]}>
          <section
            className={isLinkList ? styles["text-placeholder"] : undefined}
          >
            {childContent ? (
              childContent
            ) : (
              <>
                {isRichText && (
                  <RichTextDisplay
                    richText={content}
                    tinyMceRichText={contentTinyMce}
                    richTextStyles
                  />
                )}
                {isLinkList && (
                  <ol className="flex flex-col gap-2">
                    {content.filter(Boolean).map((link, i) => {
                      const selfId = `acc-link-${item}-${i}`;
                      return (
                        <li key={`${link.url}${link.linkText}${i}`}>
                          <Cta
                            aria-expanded="false"
                            type="tertiary"
                            {...link}
                            icon="icon-arrow"
                            id={selfId}
                            ariaLabelledBy={`${selfId} ${contextLabelId}`}
                          />
                        </li>
                      );
                    })}
                  </ol>
                )}
                {!isRichText && !isLinkList && content}
              </>
            )}
          </section>
        </div>
      </div>
    </li>
  );
};

export default AccordionItem;
